import { Injectable, inject } from '@angular/core';
import { Loader, Library } from '@googlemaps/js-api-loader';
import { GOOGLE_MAPS_LOADER_OPTIONS } from '../constants/google-maps';

@Injectable({ providedIn: 'root' })
export class MapLoader {
  private readonly defaultOptions = inject(GOOGLE_MAPS_LOADER_OPTIONS);
  private loader: Loader | null = null;

  private getLoader(): Loader {
    if (!this.loader) {
      this.loader = new Loader(this.defaultOptions);
    }
    return this.loader;
  }

  public importLibrary<T = any>(name: Library): Promise<T> {
    return this.getLoader().importLibrary(name) as Promise<T>;
  }
}
